import React, { useState } from "react";
import { IImovelFocus } from "../../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { ModalDivX } from "../../../ModalDivX";
import { Button, Container } from "./styles";
import { MunicipioSelector } from "../../../MunicipioSelector";
import { IPrefeitura } from "../../../../Hooks/usePrefeitura";
import { Alert } from "../../../Error/Alert";
import { ModalLoader } from "../../../ModalLoader";
import api from "../../../../Services/api";
import { isRural } from "../../../../Utils/isRural";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  handleSetImovel(im: IImovelFocus): void;
  imovel: IImovelFocus;
}

export function ModalMunicipio({
  open,
  onClose,
  handleSetImovel,
  imovel,
}: Props) {
  const [prefFocus, setPrefFocus] = useState({} as IPrefeitura);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  async function post() {
    try {
      setLoading(true);
      const { data } = await api.patch<IImovelFocus>(
        `/imovel${isRural() ? "-rural" : ""}/alterar-municipio`,
        {
          ID: imovel.ID,

          PREFEITURA_ID: prefFocus.ID,
        }
      );
      imovel.PREFEITURA_ID = data.PREFEITURA_ID;

      handleSetImovel(imovel);
      onClose();
    } catch (error) {
      setError({
        title: "Ops!",
        message: `Não foi possível alterar o município do imóvel ${imovel.NUMERO}, tente novamente mais tarde!`,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <MunicipioSelector
          initialValue={imovel.PREFEITURA_ID}
          execute={(item: IPrefeitura) => {
            setPrefFocus(item);
          }}
        />
        <Button onClick={post}>Confirmar</Button>
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </Modal>
  );
}
